import { z } from 'zod';

// Mirror of the DB enum types in apps/api migration 003. Single source of
// truth for both FE form dropdowns and BE validation. Values use the
// underscore form to match SQL-friendly identifiers; UI formats for display.

export const CompanyType = z.enum(['LLC', 'C_CORP', 'S_CORP']);
export type CompanyType = z.infer<typeof CompanyType>;

export const DocumentKind = z.enum([
  'resume',
  'voided_check',
  'w9',
  'coi',
  'visa',
  'cert_of_incorporation',
  'driver_license',
  'signed_contract',
  'contract_template',
  'other',
]);
export type DocumentKind = z.infer<typeof DocumentKind>;

export const DocumentUploadedBy = z.enum(['admin', 'contractor', 'esign_webhook']);
export type DocumentUploadedBy = z.infer<typeof DocumentUploadedBy>;

// Document owner grouping (T-056): business docs vs the individual resource's.
export const DocumentScope = z.enum(['business', 'resource']);
export type DocumentScope = z.infer<typeof DocumentScope>;

// Single source of truth for which scope a document kind belongs to — shared by
// the upload route (stamps scope), the onboarding form, and contractor detail
// (both group by scope). Resource-owned: driver's license + visa. Everything
// else (W-9, COI, voided check, cert of incorporation, resume, etc.) is business.
const RESOURCE_KINDS = new Set<DocumentKind>(['driver_license', 'visa']);
export function documentScopeForKind(kind: DocumentKind): DocumentScope {
  return RESOURCE_KINDS.has(kind) ? 'resource' : 'business';
}

export const EngagementStatus = z.enum(['pending', 'active', 'ended']);
export type EngagementStatus = z.infer<typeof EngagementStatus>;

export const OnboardingState = z.enum([
  'draft',
  'pending_contractor_input',
  'pending_contract_signature',
  'pending_admin_signature',
  'active',
  'expired',
  'cancelled',
]);
export type OnboardingState = z.infer<typeof OnboardingState>;
